import React, { useState } from "react";
import { connect } from "react-redux";
import { SERVER_URL } from "../../constants/constants.js";
import { customFetch } from "../../components/common/fetchWrapper";
import { alertActions } from "../../actions";
import { JotformEmbed } from "./JotformEmbed";

function Manifest(props) {
  const { org } = props;
  const org_id = org.current_org_id;

  const current_org = org.list?.filter(
    (o) => o.org_id == org_id
  )[0];

  const jotform_code = current_org.jotform_code;
  const allow_shipping_label = current_org.allow_shipping_label;
  const manifest_link = current_org.manifest_link;

  const [showSpinner, setShowSpinner] = useState(false);

  const spinner = require("../../images/spinner-purple.svg").default;


  const generateLabel = () => {
    setShowSpinner(true);
    const url = SERVER_URL + "/org/" + org_id + "/label";
    customFetch("GET", url, null, null).then(
      (info) => {
        setShowSpinner(false);
        window.open(info.label_url, "fedex-label.pdf");

      }
    )

  };

  return (
    <div className="manifestBackground">
      <div className="shippingButtonDiv">
        {
          allow_shipping_label &&
          <button className="classifyFormButton" onClick={generateLabel}>
            Generate Shipping Label
          </button>
        }
        <br />
        {
          showSpinner &&
          <div className="promptArea">
            Generating label...<br /><img src={spinner} alt="spinner" /><br />

          </div>
        }
      </div>

      {
        manifest_link &&
        <div className="promptArea">
          <a href={manifest_link} target="_blank">View previous manifest submissions (external link)</a>
        </div>
      }

      <div className="manifestDiv">

        {
          jotform_code &&
          <JotformEmbed src={jotform_code} scrolling="yes" />
        }
      </div>
    </div>

  );

}

function mapStateToProps(state) {
  const { org } = state;
  return {
    org,
  };
}

const connectedManifest = connect(mapStateToProps)(Manifest);
export { connectedManifest as Manifest };
